import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';

export const useStyles = makeStyles(() =>
  createStyles({
    boxContainer: {
      '& .MuiOutlinedInput-root': {
        height: '60px',
        borderRadius: '6px',
      },

      '& input': {
        fontSize: '14px',
      },
      transition: '300ms',
      overflow: 'hidden',
      '& .MuiInputBase-input': {
        backgroundPosition: 0,
      },
    },
    checkboxContainer: {
      marginTop: 5,
      '& .MuiFormControlLabel-root': {
        marginTop: -4,
      },
    },
    extraContainer: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      margin: '10px 0 8px',
      alignItems: 'center',
      '& a, & span': {
        fontSize: '14px',
      },
      '& a': {
        color: '#3e8bff',
      },
    },
    link: {
      color: '#3e8bff',
      textDecoration: 'none',
    },
    buttonCls: {
      height: '60px !important',
      borderStyle: 'solid',
      // borderImageSource: 'linear-gradient(253deg, #d51bff, #00d4ff)',
      // borderImageSource: 'linear-gradient(253deg, #3e8bff, #3e8bff)',
      // backgroundImage: 'linear-gradient(to bottom, #0c0f14, #26292f), linear-gradient(253deg, #d51bff, #00d4ff)',
      // backgroundOrigin: 'border-box',
      // backgroundClip: 'content-box, border-box',
      borderRadius: '8px !important',
      padding: 1,
      fontSize: 16,
      // maxWidth: 390,
    },
    registerBtn: {
      borderStyle: 'solid',
      // borderWidth: '1px',
      // borderImageSource: 'linear-gradient(253deg, #d51bff, #00d4ff)',
      border: `2px solid ${COLORS.PRIMARY}`,
      backgroundImage: 'linear-gradient(to bottom, #0c0f14, #26292f)',
      backgroundOrigin: 'border-box',
      backgroundClip: 'content-box, border-box',
      borderRadius: '8px !important',
      padding: 1,
      fontSize: 16,
      // boxShadow: '2px 1000px 1px #fff inset',
    },
    loginHead: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',

      '& span': {},
    },
    loginFooter: {
      marginTop: 40,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '& *': {
        fontSize: '14px',
      },
      '& span': {},
    },
    facebookBtn: {
      background: '#1877f2',
    },
    facebookIcon: {
      position: 'absolute',
      left: 20,
      '& path': {
        fill: '#fff',
      },
    },
    googleBtn: {
      fontWeight: 'bold',
      background: '#fff',
      color: '#0d1117',

      '&:hover': {
        background: '#ccc',
      },
    },
    googleIcon: {
      fontSize: 20,
      position: 'absolute',
      left: 20,
    },
    input: {
      // maxWidth: 390,
      borderRadius: 8,
      fontWeight: 400,
      '& input': {
        fontSize: 14,
      },
      '& .MuiInputBase-root': {
        paddingLeft: 20,
        borderRadius: 8,
        background: '#0e1319',
      },

      '& .MuiFormHelperText-root': {
        marginLeft: 0,
      },
    },
    startIcon: {
      fontSize: 20,
      marginRight: 5,
    },
  }),
);
